module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-contact-section"
  }, [_c('div', {
    staticClass: "custom-contact-section__container"
  }, [_c('div', {
    staticClass: "custom-contact-section__left"
  }, [_c('div', {
    staticClass: "custom-contact-section__left--title"
  }, [_vm._t("title", null, {
    "content": _vm.props.title
  })], 2), _c('div', {
    staticClass: "custom-contact-section__left--body"
  }, [_vm._t("body", null, {
    "content": _vm.props.body
  })], 2), _c('div', {
    staticClass: "custom-contact-section__left--address"
  }, [_vm._t("address", null, {
    "content": _vm.props.address
  })], 2), _c('div', {
    staticClass: "custom-contact-section__left--subtitle"
  }, [_vm._t("subtitle", null, {
    "content": _vm.props.subtitle
  })], 2), _c('div', {
    staticClass: "custom-contact-section__left--hours"
  }, [_vm._t("hours", null, {
    "content": _vm.props.hours
  })], 2)]), _c('div', {
    staticClass: "custom-contact-section__right"
  }, [_c('div', {
    staticClass: "custom-contact-section__right--map"
  }, [_vm._t("map", null, {
    "content": _vm.props.map
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62f955f1","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-contact-section/custom-contact-section.pug
// module id = 594
// module chunks = 1